import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Typography from '@mui/material/Typography'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import type { HighlightRef } from '../types/models'

interface Props {
  sourceQuote?: string | null
  sourceHighlight?: HighlightRef | null
}

export default function EvidenceCard({ sourceQuote, sourceHighlight }: Props) {
  const navigate = useNavigate()

  if (!sourceQuote) return null

  const footer = sourceHighlight
    ? `— ${sourceHighlight.bookTitle}${sourceHighlight.location ? ', ' + sourceHighlight.location : ''}`
    : null

  const handleClick = () => {
    if (sourceHighlight) {
      navigate(`/library/${sourceHighlight.bookId}#highlight-${sourceHighlight.highlightId}`)
    }
  }

  const cardContent = (
    <Box sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
        <MenuBookOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1 }}>
          From your highlights
        </Typography>
      </Box>
      {/* sourceQuote is a highlight quoted verbatim from the user's book — see
          Ask.tsx SourceCard for why overflowWrap is needed on this kind of text. */}
      <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 1, overflowWrap: 'anywhere' }}>
        {sourceQuote}
      </Typography>
      {footer && (
        <Typography variant="caption" color="text.secondary">
          {footer}
        </Typography>
      )}
    </Box>
  )

  return (
    <Card
      elevation={0}
      sx={{
        mt: 2,
        bgcolor: 'action.hover',
        borderRadius: 2,
      }}
    >
      {sourceHighlight ? (
        <CardActionArea onClick={handleClick} aria-label="From your highlights">
          {cardContent}
        </CardActionArea>
      ) : (
        cardContent
      )}
    </Card>
  )
}
